<template>
  <Swiper
    :modules="modules"
    :slides-per-view="1.3"
    :space-between="12"
    class="mt-10 w-100 position-relative"
    :breakpoints="{
      300: { spaceBetween: 12, slidesPerView: 1.5 },
      450: { spaceBetween: 12, slidesPerView: 1.7 },
      600: { spaceBetween: 24, slidesPerView: 2.3 },
      768: { spaceBetween: 24, slidesPerView: 2.7 },
      1024: { spaceBetween: 36, slidesPerView: 3.3 },
      1264: { spaceBetween: 48, slidesPerView: 3.7 }
    }"
    :style="{ overflow: 'hidden' }"
    :navigation="{
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    }"
    :pagination="{
      clickable: false,
      el: '.swiper-pagination'
    }"
  >
    <div class="d-flex align-center justify-end h-60px position-relative">
      <div class="swiper-pagination w-200px h-2px mt-5 mb-5 mb-md-5" />
      <div class="d-flex align-center justify-end gap-10 h-100 mr-2">
        <div class="swiper-button-prev h-40px w-40px fs-20 rounded-circle" />
        <div class="swiper-button-next h-40px w-40px fs-20 rounded-circle" />
      </div>
    </div>
    <SwiperSlide v-for="item in items" :key="item.Title" class="h-auto">
      <ContentItem :model-value="item" :contentType="contentType" />
    </SwiperSlide>
  </Swiper>
</template>

<script>
import ContentItem from '@Components/ContentItem.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default {
  name: 'SelectedContentSwiper',
  components: { ContentItem, Swiper, SwiperSlide },
  props: {
    contentType: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modules: [Autoplay, Navigation, Pagination]
    };
  }
};
</script>

<style lang="scss" scoped>
:deep() {
  @import 'swiper/scss';
  @import 'swiper/scss/autoplay';
  @import 'swiper/scss/navigation';
  @import 'swiper/scss/pagination';
}
.swiper-button-prev,
.swiper-button-next {
  background-color: #ffffff !important;
  position: static !important;
}
.swiper-pagination {
  position: static !important;
  margin-bottom: 0px !important;
  margin-top: -17px !important;
}
.swiper-button-prev:hover,
.swiper-button-next:hover {
  background-color: #9c9a9a !important;
  opacity: 0.8 !important;
  transition: all 0.3s ease-in-out !important;
  transform: scale(1.1) !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2) !important;
}
</style>
